import pages from '../screens/all-pages';

export const ROUTE_LOGIN = 'https://central.zetta-system.com';
export const ROUTE_LOGIN_MANUAL = '/account/login';
export const ROUTE_HANDLE = '/account/handle';

export const KEY_ROUTE_MAIN = '@ROUTES/ROUTE_MAIN';
export const KEY_ROUTE_HOME = '@ROUTES/ROUTE_HOME';
//Register
export const KEY_ROUTE_REGISTER = '@ROUTES/ROUTE_REGISTER';
export const KEY_ROUTE_REGISTER_QR = '@ROUTES/ROUTE_REGISTER_QR';
export const KEY_ROUTE_REGISTER_PRODUCT = '@ROUTES/ROUTE_REGISTER_PRODUCT';
export const KEY_ROUTE_WARRANTY_SCAN_QR = '@ROUTES/ROUTE_WARRANTY_SCAN_QR';
export const KEY_ROUTE_HOME_SCENE = '@ROUTES/ROUTE_HOME_SCENE';
//EnterTel
export const KEY_ROUTE_ENTERTEL = '@ROUTES/ROUTE_ENTERTEL';

//Home
export const KEY_ROUTE_CLAIM_REGISTER = '@ROUTES/ROUTE_CLAIM_REGISTER';

//profile
export const KEY_ROUTE_PROFILE_SCENE = '@ROUTES/ROUTE_PROFILE_SCENE';

//term
export const KEY_ROUTE_TERM_WARRANTY = '@ROUTES/ROUTE_TERM_WARRANTY';

export const ROUTES_PATH = {
  ROUTE_MAIN: {
    KEY: KEY_ROUTE_MAIN,
    PATH: '/',
    LABEL: 'หน้าหลัก',
  },
  ROUTE_ENTERTEL: {
    KEY: KEY_ROUTE_ENTERTEL,
    PATH: '/entertel',
    LABEL: 'หน้ากรอกเบอร์โทรศัพท์',
    COMPONENT: pages.EnterTel,
  },
  ROUTE_HOME: {
    KEY: KEY_ROUTE_HOME,
    PATH: '/home',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.HomeScene,
  },
  ROUTE_CLAIM_REGISTER: {
    KEY: KEY_ROUTE_CLAIM_REGISTER,
    PATH: '/claim/register',
    LABEL: 'ลงทะเบียนเคลม',
    COMPONENT: pages.ClaimScene,
  },

  ROUTE_REGISTER: {
    KEY: KEY_ROUTE_REGISTER,
    PATH: '/warranty',
    LABEL: 'ลงทะเบียนรับประกันสินค้า',
    COMPONENT: pages.Register,
  },
  ROUTE_REGISTER_QR: {
    KEY: KEY_ROUTE_REGISTER_QR,
    PATH: '/warranty/qr',
    LABEL: 'ลงทะเบียนรับประกันสินค้า QR',
    COMPONENT: pages.RegisterQR,
  },
  ROUTE_WARRANTY_SCAN_QR: {
    KEY: KEY_ROUTE_WARRANTY_SCAN_QR,
    PATH: '/warranty/scan-qr',
    LABEL: 'สแกน QR Code รับประกัน',
    COMPONENT: pages.WarrantyScanQR,
  },
  ROUTE_REGISTER_PRODUCT: {
    KEY: KEY_ROUTE_REGISTER_PRODUCT,
    PATH: '/warranty/product',
    LABEL: 'ลงทะเบียนรับประกันสินค้า',
    COMPONENT: pages.RegisterProduct,
  },
  ROUTE_PROFILE: {
    KEY: KEY_ROUTE_PROFILE_SCENE,
    PATH: '/profile',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.ProfileScene,
  },
  ROUTE_TERM_WARRANTY: {
    KEY: KEY_ROUTE_TERM_WARRANTY,
    PATH: '/term/warranty',
    LABEL: 'ข้อตกลงการรับประกันสินค้า',
    COMPONENT: pages.TermWarranty,
  },
};

function getKeyLowerCase(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));
}

export const ROUTES_MENU = [getKeyLowerCase(ROUTES_PATH.ROUTE_REGISTER)];

export const FULLSCREEN_ROUTES = [ROUTES_PATH.ROUTE_PROFILE.KEY];
export const WITHOUT_MENUSCEEN_ROUTES = [
  ROUTES_PATH.ROUTE_REGISTER.KEY,
  ROUTES_PATH.ROUTE_ENTERTEL.KEY,
  ROUTES_PATH.ROUTE_REGISTER_PRODUCT.KEY,
  ROUTES_PATH.ROUTE_WARRANTY_SCAN_QR.KEY,
  ROUTES_PATH.ROUTE_TERM_WARRANTY.KEY,
  ROUTES_PATH.ROUTE_CLAIM_REGISTER.KEY,
];
export const WITH_MENU_SCEEN_ROUTES = [ROUTES_PATH.ROUTE_HOME.KEY];
